import { AlternateColorProps } from '@components/Product/Details/_ProductSelection';
import { getColor } from '@components/Product/variables';
import buildLinkObj from '@repo/ui/src/functions/build-link';
import { AlternateColorDot, AlternateColorsContainer } from './styles';

interface Props extends AlternateColorProps {
  color: string;
}

const AlternateColors = ({ colors, color }: Props) => (
  <AlternateColorsContainer color={getColor(color)}>
    <a className="color-link">
      <span className="dot" />
      {color}
    </a>
    {colors.map((altColor, i) => (
      <a key={`Color-${i}`} href={buildLinkObj(altColor.link).href}>
        <AlternateColorDot color={getColor(altColor.color)} />
        {altColor.color}
      </a>
    ))}
  </AlternateColorsContainer>
);

export default AlternateColors;
